const infoIES = [
  {
    uf: "AM",
    nome: "Amazonas",
    telefone: "0800 771 5001",
    cidades: [
      {
        nome: "Manaus",
        endereco: {
          logradouro: "Rua Natal",
          numero: "300",
          bairro: "Adrianópolis",
          cidade: "Manaus",
          estado: "AM",
        },
        nomeUniversidade: "FMF WYDEN",
        acessibilidade: true,
      },
    ],
  },
  {
    uf: "BA",
    nome: "Bahia",
    telefone: "0800 771 5001",
    cidades: [
      {
        nome: "Salvador",
        endereco: {
          logradouro: "Av. Luis Viana Filho",
          numero: "3172",
          bairro: "Paralela",
          cidade: "Salvador",
          estado: "BA",
        },
        nomeUniversidade: "UNIRUY",
        acessibilidade: false,
      },
    ],
  },
  {
    uf: "CE",
    nome: "Ceará",
    telefone: "0800 771 5001",
    cidades: [
      {
        nome: "Fortaleza",
        endereco: {
          logradouro: "Rua Antônio Gomes Guimarães",
          numero: "150",
          bairro: "Papicu",
          cidade: "Fortaleza",
          estado: "CE",
        },
        nomeUniversidade: "UNIFANOR",
        acessibilidade: true,
      },
      {
        nome: "Fortaleza",
        endereco: {
          logradouro: "Av. Bezerra de Menezes",
          numero: "1277",
          bairro: "São Gerardo",
          cidade: "Fortaleza",
          estado: "CE",
        },
        nomeUniversidade: "UNIFANOR",
        acessibilidade: false,
      },
    ],
  },
  {
    uf: "MG",
    nome: "Minas Gerais",
    telefone: "0800 771 5001",
    cidades: [
      {
        nome: "Belo Horizonte",
        endereco: {
          logradouro: "Av. Carlos Luz",
          numero: "220",
          bairro: "Bairro Caiçaras ",
          cidade: "Belo Horizonte",
          estado: "MG",
        },
        nomeUniversidade: "NEWTON PAIVA",
        acessibilidade: true,
      },
      {
        nome: "Belo Horizonte",
        endereco: {
          logradouro: "Rua Marechal Foch",
          numero: "15",
          bairro: "Bairro Grajaú",
          cidade: "Belo Horizonte",
          estado: "MG",
        },
        nomeUniversidade: "NEWTON PAIVA",
        acessibilidade: false,
      },
    ],
  },
  {
    uf: "MA",
    nome: "Maranhão",
    telefone: "0800 771 5001",
    cidades: [
      {
        nome: "Imperatriz",
        endereco: {
          logradouro: "Av. Prudente de Morais",
          numero: "s/n",
          bairro: "Parque Sanharol",
          cidade: "Imperatriz",
          estado: "MA",
        },
        nomeUniversidade: "FACIMP",
        acessibilidade: true,
      },
    ],
  },
  {
    uf: "PA",
    nome: "Pará",
    telefone: "0800 771 5001",
    cidades: [
      {
        nome: "Belém",
        endereco: {
          logradouro: "Tv. Tupinambás",
          numero: "461",
          bairro: "Batista Campos",
          cidade: "Belém",
          estado: "PA",
        },
        nomeUniversidade: "FACI WYDEN",
        acessibilidade: true,
      },
    ],
  },
  {
    uf: "PE",
    nome: "Pernambuco",
    telefone: "0800 771 5001",
    cidades: [
      {
        nome: "Recife",
        endereco: {
          logradouro: "Rua Jean Émile Favre",
          numero: "422",
          bairro: "Imbiribeira",
          cidade: "Recife",
          estado: "PE",
        },
        nomeUniversidade: "UNIFBV",
        acessibilidade: false,
      },
      {
        nome: "Caruaru",
        endereco: {
          logradouro: "Av. Adjar da Silva Casé",
          numero: "800",
          bairro: "Indianópolis",
          cidade: "Caruaru",
          estado: "PE",
        },
        nomeUniversidade: "UNIFAVIP",
        acessibilidade: false,
      },
    ],
  },
  {
    uf: "PI",
    nome: "Piauí",
    telefone: "0800 771 5001",
    cidades: [
      {
        nome: "Teresina",
        endereco: {
          logradouro: "Rua Veterinário Bugyja Brito",
          numero: "1354",
          bairro: "Horto Florestal",
          cidade: "Teresina",
          estado: "PI",
        },
        nomeUniversidade: "UNIFACID",
        acessibilidade: true,
      },
    ],
  },
  {
    uf: "SP",
    nome: "São Paulo",
    telefone: "0800 771 5001",
    cidades: [
      {
        nome: "Araçatuba",
        endereco: {
          logradouro: "Rua Antônio Afonso de Toledo",
          numero: "595",
          bairro: "Jardim Sumaré",
          cidade: "Araçatuba",
          estado: "SP",
        },
        nomeUniversidade: "UNITOLEDO",
        acessibilidade: false,
      },
      {
        nome: "Campinas",
        endereco: {
          logradouro: "Rua Dr. Sales de Oliveira",
          numero: "1661",
          bairro: "Vila Industrial",
          cidade: "Campinas",
          estado: "SP",
        },
        nomeUniversidade: "UNIMETROCAMP",
        acessibilidade: true,
      },
    ],
  },
];

import jQuery from "jquery";

import loading from "../images/loading.svg";

jQuery(document).ready(function () {
  jQuery(function () {
    let listaInfos = [];
    let listaInfosPorUF = [];
    const selectEstado = jQuery("#estadoSelect");
    const selectCidade = jQuery("#cidadeSelect");
    let valorAntigoCidade;
    let valorAntigoEstado;
    const setaSelect = `<svg width="14" class="open" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.46967 0.46967C0.762563 0.176777 1.23744 0.176777 1.53033 0.46967L7 5.93934L12.4697 0.46967C12.7626 0.176777 13.2374 0.176777 13.5303 0.46967C13.8232 0.762563 13.8232 1.23744 13.5303 1.53033L7.53033 7.53033C7.23744 7.82322 6.76256 7.82322 6.46967 7.53033L0.46967 1.53033C0.176777 1.23744 0.176777 0.762563 0.46967 0.46967Z" fill="currentColor"/></svg>`;

    //Muda a cor do texto quando estiver nas opções inciiais
    if (jQuery("#estadoSelect").text().trim() === "Estado") {
      jQuery("#estadoSelect").attr("style", "color: #A3A3A3 !important");
    }
    if (jQuery("#cidadeSelect").text().trim() === "Cidade") {
      jQuery("#cidadeSelect").attr("style", "color: #A3A3A3 !important");
    }

    jQuery(".card-unidades-container").css("padding", "0");

    // Validação dos campos;
    jQuery("#pesquisar-unidades").on("click", function (e) {
      e.preventDefault();
      destroyCarousel();

      jQuery(".content-unidades").removeClass(
        "open-cidade open-estado open-cidade3 open-cidade4"
      );
      if (selectEstado.text().trim() === "Estado") {
        jQuery("p#msg-erro-estado").css("display", "block");
        jQuery("#estadoSelect").css("border-color", "#f29292");
      } else {
        // jQuery(".card-unidades-container").removeAttr("style");
        jQuery("#pesquisar-unidades").addClass("carregando");
        jQuery("#pesquisar-unidades").html(
          `<img class='loading-unidades' src=${loading} alt='icone de loading'/>`
        );
        setTimeout(() => {
          jQuery.each(listaInfos, function (index, infoCard) {
            jQuery(".card-unidades-container").append(infoCard);
            // jQuery(".card-unidades-container").css({ opacity: 0, height: 0,padding: 0,'min-height':0});
          });

          jQuery(
            ".card-unidades-container, .select-unidades, .content-unidades"
          ).addClass("hasContent");
          jQuery(".card-unidades-container").removeAttr("style");
          if (listaInfos.length > 1) {
            setTimeout(() => {
              slickCarousel();
              taggingCarrousel();
              jQuery(".card-unidades-container, .content-unidades").addClass(
                "has-multiple"
              );
            }, 1);
          }

          valorAntigoCidade = selectCidade.text().trim();
          valorAntigoEstado = selectEstado.text().trim();
          jQuery("#pesquisar-unidades").removeClass("carregando");
          jQuery("#pesquisar-unidades").html("<span>Pesquisar unidades</span>");
          jQuery("#pesquisar-unidades").attr("disabled", "disabled");
        }, 1000);
      }
      valorAntigoCidade;
      valorAntigoEstado;
    });

    // Monta lista de estados
    jQuery.each(infoIES, function (index, obj) {
      var removeAcento = obj.nome
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      var remontaNome = removeAcento.split(" ").join("-");

      jQuery("<li/>", {
        value: obj.uf,
        text: obj.nome,
      })
        .attr("data-element", `option_${remontaNome.toLowerCase()}`)
        .appendTo(jQuery("#faculdade-ideal .select.estado ul"));
    });

    function compare(a, b) {
      if (a.nome < b.nome) return -1;
      if (a.nome > b.nome) return 1;
      return 0;
    }

    // Monta a lista de cidades de acordo com o estado selecionado.
    jQuery("#faculdade-ideal .select.estado ul").on("click", function (e) {
      destroyCarousel();
      jQuery("#faculdade-ideal .select.cidade ul li").remove();
      jQuery("p#msg-erro-estado").css("display", "none");
      const estadoClicado = e.target.attributes[0].value;

      jQuery("#pesquisar-unidades").removeAttr("disabled");
      jQuery(".card-unidades-container").css("padding", "0");
      jQuery(".content-unidades").removeClass("open-estado");

      //limpa lista de informações
      jQuery(".card-unidades-container .card-info-unidade").remove();

      jQuery(
        ".card-unidades-container, .select-unidades, .content-unidades"
      ).removeClass("hasContent has-multiple");

      // Muda o texto do botão para o item que foi clicado.
      if (estadoClicado === "dropdown-menu show") {
        selectEstado.html("Estado" + setaSelect);
        jQuery("#estadoSelect").css("color", "#A3A3A3");
      } else {
        selectEstado.html(e.target.innerText + setaSelect);
        jQuery(selectEstado).removeAttr("style");
      }
      selectCidade.html("Cidade" + setaSelect);
      jQuery("#cidadeSelect").css("color", "#A3A3A3");

      listaInfos = [];
      listaInfosPorUF = [];
      let listaMostraDetalhe = [];

      jQuery.each(infoIES, function (index, obj) {
        if (obj.uf === estadoClicado) {
          //passa o array para a variável
          listaMostraDetalhe = obj;

          obj.cidades.sort(compare);

          let antigo;

          jQuery.each(obj.cidades, function (index, cidade) {
            if (antigo !== cidade.nome) {
              var removeAcento = cidade.nome
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "");
              var remontaNome = removeAcento.split(" ").join("-");

              //cria lista de cidades por UF
              jQuery("<li/>", {
                value: cidade.endereco.estado,
                text: cidade.nome,
              })
                .attr("data-element", `option_${remontaNome.toLowerCase()}`)
                .appendTo(jQuery("#faculdade-ideal .select.cidade ul"));

              antigo = cidade.nome;
            }

            // Monta elemento das informações por cidades baseada na UF.
            let infoCard = `
                      <div class="card-info-unidade">
                          <p class="nome-ies">${cidade.nomeUniversidade}</p>
                          <p class="logradouro-ies">${cidade.endereco.logradouro}</p>
                          <p class="numero-ies">Nº ${cidade.endereco.numero}</p>
                          <p class="bairro-ies">${cidade.endereco.bairro}, ${cidade.endereco.cidade} / ${cidade.endereco.estado}</p>
                          <p class="telefone-ies">Telefone: ${obj.telefone}</p>
                      </div>
                       `;

            listaInfos.push(infoCard);
            listaInfosPorUF.push(infoCard);
            // jQuery(".card-unidades-container").append(infoCard);
            // jQuery(".card-unidades-container").addClass("hasContent");
            // jQuery(".card-unidades-container").css({
            //   opacity: 0,
            //   height: 0,
            //   padding: 0,
            //   "min-height": 0,
            // });
          });
        }
        listaMostraDetalhe;
      });
    });

    // Altera o nome do campo cidade.
    jQuery("#faculdade-ideal .select.cidade ul").on("click", function (e) {
      destroyCarousel();
      var quantidadeCidadesSelecionadas = e.target.innerText
        .toString()
        .split("\n");
      if (quantidadeCidadesSelecionadas.length > 1) {
        selectCidade.html("Cidade" + setaSelect);
        jQuery("#cidadeSelect").css("color", "#A3A3A3");
        listaInfos = [];
        listaInfos = listaInfosPorUF;
      } else {
        selectCidade.html(e.target.innerText + setaSelect);
        jQuery(selectCidade).removeAttr("style");
        listaInfos = [];
      }
      jQuery("#pesquisar-unidades").removeAttr("disabled");
      jQuery(".content-unidades").removeClass(
        "open-cidade open-estado open-cidade3 open-cidade4"
      );
      jQuery(".card-unidades-container").css("padding", "0");

      //limpa lista de informações
      jQuery(".card-unidades-container .card-info-unidade").remove();

      jQuery(
        ".card-unidades-container, .select-unidades, .content-unidades"
      ).removeClass("hasContent has-multiple");

      jQuery.each(infoIES, function (index, obj) {
        let quantidadePorCidade = [];
        jQuery.each(obj.cidades, function (index, cidade) {
          if (
            cidade.nome === jQuery("#cidadeSelect").text().trim() &&
            quantidadeCidadesSelecionadas.length === 1
          ) {
            quantidadePorCidade.push(cidade);
            // Monta elemento das informações por cidades baseada na UF.
            let infoCard = `
                      <div class="card-info-unidade">
                          <p class="nome-ies">${cidade.nomeUniversidade}</p>
                          <p class="logradouro-ies">${cidade.endereco.logradouro}</p>
                          <p class="numero-ies">Nº ${cidade.endereco.numero}</p>
                          <p class="bairro-ies">${cidade.endereco.bairro}, ${cidade.endereco.cidade} / ${cidade.endereco.estado}</p>
                          <p class="telefone-ies">Telefone: ${obj.telefone}</p>
                      </div>
                       `;
            listaInfos.push(infoCard);
          }
        });
      });
    });

    // Altera o estilo quando o select estiver aberto
    selectEstado.on("click", (e) => {
      e.stopPropagation();
      changeStyleSeta("estadoSelect");
      jQuery(".content-unidades").toggleClass("open-estado");

      //Fecha o outro select
      jQuery(
        "#faculdade-ideal .select.cidade button, #faculdade-ideal .select.cidade ul"
      ).removeClass("show");
      jQuery("#faculdade-ideal .select.cidade button").attr(
        "aria-expanded",
        "false"
      );
    });

    selectCidade.on("click", (e) => {
      e.stopPropagation();
      var quantidadeCidades = jQuery(
        "#faculdade-ideal .select.cidade ul li"
      ).length;
      changeStyleSeta("cidadeSelect");
      if (quantidadeCidades === 2) {
        jQuery(".content-unidades").toggleClass("open-cidade");
      } else if (quantidadeCidades === 3) {
        jQuery(".content-unidades").toggleClass("open-cidade3");
      } else if (quantidadeCidades === 4) {
        jQuery(".content-unidades").toggleClass("open-cidade4");
      }

      //Fecha o outro select
      jQuery(
        "#faculdade-ideal .select.estado button, #faculdade-ideal .select.estado ul"
      ).removeClass("show");
      jQuery("#faculdade-ideal .select.estado button").attr(
        "aria-expanded",
        "false"
      );
    });

    function changeStyleSeta(id) {
      const selectClidado = id;
      const outroSelect =
        id === "estadoSelect" ? "cidadeSelect" : "estadoSelect";

      jQuery(`#${selectClidado}, #${selectClidado} svg`).toggleClass("open");
      jQuery(`#${outroSelect}, #${outroSelect} svg`).removeClass("open");
    }

    // Quando hovuer clique no documento ele remove a class open
    jQuery(document).on("click", function () {
      jQuery(
        "#estadoSelect, #estadoSelect svg, #cidadeSelect, #cidadeSelect svg"
      ).removeClass("open");

      jQuery(".content-unidades").removeClass(
        "open-cidade open-estado open-cidade3 open-cidade4"
      );
    });
  });

  function taggingCarrousel() {
    let dots = jQuery(".slick-dots li");
    let btnNext = jQuery(".slick-next");
    let btnPrev = jQuery(".slick-prev");

    jQuery(btnNext).attr("data-element", `button_proximo-slide`);
    jQuery(btnPrev).attr("data-element", `button_slide-anterior`);

    jQuery.each(dots, function (index, dot) {
      jQuery(dot).attr("data-element", `button_faculdade-${index + 1}`);
    });
  }

  //Carrousel
  function slickCarousel() {
    jQuery("#carrousel").slick({
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      speed: 500,
      fade: true,
      cssEase: "linear",
    });
  }

  function destroyCarousel() {
    if (jQuery("#carrousel").hasClass("slick-initialized")) {
      jQuery("#carrousel").slick("destroy");
      jQuery(".card-unidades-container").removeClass("hasContent");
    }
  }
});
